var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"no-underline block",attrs:{"to":{ name: 'broker-list' },"tag":"a"}},[_vm._v("\n\n  Datapad Admin\n\n")])}
var staticRenderFns = []

export { render, staticRenderFns }